import { gql, useQuery } from '@apollo/client';
import { GetSearchRecommendationsInput, Query } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

const GET_SEARCH_RECOMMENDATIONS = gql`
  query getSearchRecommendations(
    $tenantID: ID!
    $maxPerType: Int!
    $shouldRecompute: Boolean!
  ) {
    getSearchRecommendations(
      request: {
        tenantID: $tenantID
        maxPerType: $maxPerType
        shouldRecompute: $shouldRecompute
      }
    ) {
      reasons {
        id
        displayName
        type
      }
      entities {
        id
        displayName
        type
      }
    }
  }
`;

export function useFetchLabelRecommendations(shouldRecompute: boolean = false) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { data, loading, error, refetch } = useQuery<
    Query,
    GetSearchRecommendationsInput
  >(GET_SEARCH_RECOMMENDATIONS, {
    variables: {
      tenantID,
      shouldRecompute,
      maxPerType: 6,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return {
    error,
    refetch,
    loading: data ? false : loading,
    recommendations: {
      reasons: data?.getSearchRecommendations?.reasons || [],
      entities: data?.getSearchRecommendations?.entities || [],
    },
  };
}
